import { RobotVacuumIcon } from './RobotVacuumIcon';

/**
 * author: Roberto Graham
 * id E091C285-7AA8-4907-9398-EBFDAC7A179D
 * name robot-vacuum
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-vacuum.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const RoombaIcon = RobotVacuumIcon;
export default RoombaIcon